export default __webpack_public_path__ + "static/media/UI_ClickDrag-01.f9e621b7.svg";